module.exports = __webpack_public_path__ + "img/UI_shouji_BG_02_01_e5a07af90.png";